import { request } from "./http";

export interface AnalyticsSummary {
  total_return_pct: number;
  sharpe_ratio: number;
  sortino_ratio: number;
  calmar_ratio: number;
  max_drawdown_pct: number;
  win_rate: number;
  profit_factor: number;
  expectancy: number;
  total_trades: number;
  winning_trades: number;
  losing_trades: number;
  avg_win: number;
  avg_loss: number;
  largest_win: number;
  largest_loss: number;
  by_asset_class: Record<
    string,
    { trades: number; win_rate: number; pnl: number }
  >;
  monthly_returns: { month: string; pnl: number }[];
  starting_equity: number;
  trading_days: number;
}

export interface RiskLimit {
  name: string;
  current: string;
  max: string;
  status: "ok" | "warning" | "danger" | string;
}

export interface RiskSnapshot {
  portfolio_heat: number;
  max_portfolio_heat: number;
  daily_pnl: number;
  daily_pnl_pct: number;
  max_daily_loss: number;
  drawdown_pct: number;
  max_drawdown_pct: number;
  peak_equity: number;
  current_equity: number;
  circuit_breaker: string;
  margin_used: number;
  margin_available: number;
  margin_utilization_pct?: number;
  net_exposure_pct?: number;
  exposure_by_asset_class?: Record<string, number>;
  exposure_by_direction?: Record<string, number>;
  limits?: RiskLimit[];
}

export const analytics = {
  summary: () => request<AnalyticsSummary>("/piggy/api/analytics"),
  equityCurve: () =>
    request<{ data: { timestamp: number; equity: number }[] }>("/piggy/api/equity-curve"),
  journal: () =>
    request<{ entries: { time: string; type: string; message?: string }[] }>(
      "/piggy/api/journal",
    ),
  risk: () => request<RiskSnapshot>("/piggy/api/risk"),
};
